import { IntegrationType } from '@baserow/modules/core/integrationTypes'
import ttlockIntegration from '@baserow/modules/integrations/ttlock/assets/images/ttlock.svg?url'
import TTLockForm from '@baserow/modules/integrations/ttlock/components/integrations/TTLockForm'

export class TTLockIntegrationType extends IntegrationType {
  static getType() {
    return 'ttlock'
  }

  get name() {
    return this.app.$i18n.t('integrationType.ttlock')
  }

  get image() {
    return ttlockIntegration
  }

  getSummary(integration) {
    const connected = integration?.context_data?.connected
    if (!connected) {
      return this.app.$i18n.t('ttlockIntegrationType.notConnected')
    }
    return this.app.$i18n.t('ttlockIntegrationType.summary', {
      username: integration.username || '—',
    })
  }

  get formComponent() {
    return TTLockForm
  }

  getDefaultValues() {
    return { username: '', password: '', api_base_url: '' }
  }

  getOrder() {
    return 11
  }
}
